import { robotoRegular, scarpaGray200, scarpaGray25, scarpaGray500 } from '@habitech/shared';
import styled from 'styled-components';

export const Container = styled.div`
    margin: 24px 0;
    padding: 16px;
    @media ${({ theme }) => theme.screenSizes.tablet} {
        border: 1px solid ${scarpaGray200};
        border-radius: 4px;
    }

    .header_table {
        background-color: #fafafa;
        padding: 0 16px;
        margin: 16px 0px;

        :first-of-type {
            margin-top: 0px;
        }
    }
`;

export const LayoutCardsColumns = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 8px;

    .containerLabel {
        display: flex;
        gap: 8px;
        align-items: center;

        &.bg-grey {
            background-color: ${scarpaGray25};
        }

        &.gap-10 {
            gap: 10px;
            padding: 4px 8px;
        }

        font-size: 12px;
        line-height: 20px;
        font-family: ${robotoRegular};
        color: #6d6970;
        text-align: left;

        b {
            color: #252129;
        }
    }

    .label {
        font-size: 10px;
        letter-spacing: 2px;
        line-height: 10px;
        text-transform: uppercase;
        font-weight: 600;
        font-family: ${robotoRegular};
        color: ${scarpaGray500};
        text-align: left;
    }
`;
